import request from '@/utils/request'

export function getInfo() {
  return request({
    url: '/admin/admin_info',
    method: 'get'
  })
}

export function getRoles() {
  return request({
    url: '/admin/admin_menu',
    method: 'get'
  })
}
// 修改密码
export function changePassword(data) {
  return request({
    url: '/admin/admin_info_password',
    method: 'put',
    data
  })
}

export function updateInfo(data) {
  return request({
    url: '/admin/admin_info_update',
    method: 'put',
    data
  })
}

